import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ISliceFeature } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature } from './feature';

@Kb3dModel({
    token: Token.SliceFeature,
})
export class SliceFeature extends Feature implements ISliceFeature {
    static _affectedBy = new Set(ALL_GEOMETRY);
    static _affects = new Set(ALL_GEOMETRY);

    _previewVisible: boolean;
    normal: KbVector;
    intersect: KbVector;
    removeGeometry: boolean;
}
